<template>
  <div class="cc-header header">
    <input type="hidden" id="goback" value="4" />
    <div class="cc-header-left" v-if="$slots.left" >
      <slot name="left"></slot>
    </div>
    <cc-svg-icon
      v-else
      @click="goback"
      icon-class="left-arrow"
      class-name="left-arrow"
      size=".2rem"
    ></cc-svg-icon>
    <div v-if="$slots.center" class="cc-header-center">
      <slot name="center"></slot>
    </div>
    <p class="cc-header-title" v-else>{{title}}</p>
    <div class="cc-header-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cc-header-nav',
  props: {
    title: {
      type: String,
      default: ''
    },
    // 跳转的url
    url: {
      default: ''
    }
  },
  data () {
    return {
      value: ''
    }
  },
  created () {
  },
  methods: {
    goback () {
      if (this.url) {
        window.location = this.url
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
.cc-header {
  background: linear-gradient(to right,var(--APP_theme_color) , var(--APP_theme_color_colorOpacity5));
  position: static;
  height: $titleHeight;
  z-index: 20;
  @include flex(row);
  align-items: center;
  .left-arrow {
    padding: 10px;
    color: #fff;
    width: 20px;
    height: 20px;
  }
  &-title,
  &-center {
    flex: 1;
    font-size: 16px;
    display: flex;
    justify-content: center;
  }
  &-left{
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-right {
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
